


































































import { Component, Vue } from 'vue-property-decorator';
import AuthService from '@/services/auth-service';
import '../styles/login.scss';
import '../styles/fonts.scss';


@Component({
  components: {},
})

export default class Home extends Vue {
  private auth = new AuthService();
  private noEmail = false;
  private noPass = false;
  private username = '';
  private password = '';


  private login() {
    if (this.username === '') {
      this.noEmail = true;
    } else {
      this.noEmail = false;
    }

    if (this.password === '') {
      this.noPass = true;
    } else {
      this.noPass = false;
    }

    if (this.noPass || this.noEmail) {
      return;
    } else {
      this.auth.login(this.username, this.password);
    }
  }
}
